import type { WithChildren } from '@ab-core/utils/types';
import type { FC } from 'react';
import React from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import type { Placement } from 'tippy.js';
import FlagIcon from './flag';
import { TippyStyled, Wrapper } from './styled';

export type TooltipProps = WithChildren & {
    content?: React.ReactNode;
    placement?: Placement;
    keepVisible?: boolean;
    showTooltip: boolean;
    fluid?: boolean;
};
const offsetMin = 0;
const offsetMax = 20;
const Tooltip: FC<TooltipProps> = (props) => {
    const { content, showTooltip, children, placement = 'auto', keepVisible = false, fluid } = props;
    const FlagString = renderToStaticMarkup(<FlagIcon />);

    return (
        <TippyStyled
            allowHTML
            content={content}
            interactive={keepVisible}
            offset={[offsetMin, offsetMax]}
            arrow={FlagString}
            placement={placement}
            disabled={!showTooltip}
            visible
            appendTo={() => document.body}
        >
            <Wrapper fluid={fluid}>{children}</Wrapper>
        </TippyStyled>
    );
};

export default Tooltip;
